<div id="header">
  <a class="burger-icon"
     [class.active]="sidebarStatus"
     (click)="toggleMenu()">
    <span></span>
    <span></span>
    <span></span>
  </a>
  <a href="/">
    <app-yopa-logo></app-yopa-logo>
  </a>
  <app-user-dropdown></app-user-dropdown>
</div>
